/**
 * Outbound links, in one place.
 *
 * BSWA's donation page has moved before, and it is the one URL in this app that must
 * never quietly 404: the whole arrangement rests on people being able to give something
 * back to the people who recorded and freely shared these talks.
 */

export const DONATE_URL = 'https://bswa.org/support-us/donate-2/';
export const BSWA_URL = 'https://bswa.org/';
